import * as React from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';

import { CopyOutlined as FileCopyOutlined, LinkOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';

import { CHECKOUT_ELEMENTS_URL } from 'settings';
import { Space } from 'v2/components/Shared/Space';
import type { ProductOffer } from 'v2/interfaces/product';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { PricesList } from './PricesList';

type LinksModalProps = {
  isAffiliate: boolean;
  isOpen: boolean;
  closeModal: () => void;
  offer: ProductOffer;
};

function LinksModal({ isAffiliate, isOpen, closeModal, offer }: LinksModalProps) {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  function mountOfferLink(offer: ProductOffer) {
    const url = new URL(`${CHECKOUT_ELEMENTS_URL}/${offer.key}`);

    if (isAffiliate && user) {
      url.searchParams.append('a', String(user.id));
    }

    return String(url);
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    toast.success('Link copiado para a área de transferência');
  }

  return (
    <Modal open={isOpen} onCancel={closeModal} title={<strong>Links da oferta</strong>} width={700} footer={null}>
      <Typography.Text className='mb-3 block leading-6'>
        <strong id='links-modal-offer-name'>{offer.name}</strong>
      </Typography.Text>
      <p className='mb-1 text-sm leading-[22px]'>Página de pagamento (Checkout Sun)</p>
      <div className='border-border flex items-center gap-2 border px-2 py-1 pl-[13px]'>
        <LinkOutlined style={{ fontSize: 18 }} />
        <a
          id='links-modal-offer-link'
          href={mountOfferLink(offer)}
          target='_blank'
          rel='noreferrer'
          className='overflow-hidden text-sm leading-6 text-ellipsis whitespace-nowrap text-black hover:underline'
        >
          {mountOfferLink(offer)}
        </a>
        <Button
          type='text'
          size='small'
          id='links-modal-copy-button'
          className='ml-auto'
          onClick={() => copyLinkToClipboard(mountOfferLink(offer))}
          icon={<FileCopyOutlined style={{ fontSize: 18 }} />}
        />
      </div>
      {offer.prices?.length > 0 && <Space axis='vertical' size={30} />}
      <PricesList isAffiliate={isAffiliate} offer={offer} />
    </Modal>
  );
}

export { LinksModal };
